import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

interface BenefitItem {
	title: string;
	bullets?: string[];
}

interface BenefitsData {
	TITLE: string;
	ITEMS: BenefitItem[];
}

@Component({
	selector: 'app-pymes-beneficios-seguro',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule
	],
	templateUrl: './pymes-beneficios-seguro.component.html',
	styleUrls: ['./pymes-beneficios-seguro.component.scss']
})
export class PymesBeneficiosSeguroComponent implements OnInit {
	title: string = '';
	questions: BenefitItem[] = [];

	benefitImages: string[] = [
		'assets/images/pymes/Imagen1.png',
		'assets/images/pymes/Imagen2.png',
		'assets/images/pymes/Imagen3.png',
		'assets/images/pymes/Imagen4.png',
		'assets/images/pymes/Imagen5.png',
		'assets/images/pymes/Imagen6.png'
	];

	private translateService = inject(TranslateService);
	private destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		this.loadBenefitsFromTranslations();
	}

	private loadBenefitsFromTranslations(): void {
		this.translateService
			.stream('PYMES.BENEFICIOS-SALUD')
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: BenefitsData) => {
				this.title = data?.TITLE || '';
				this.questions = data?.ITEMS || [];
			});
	}

	getBenefitImage(index: number): string | null {
		return this.benefitImages[index] || null;
	}

	trackByItem(index: number, item: BenefitItem): string {
		return `${item.title}-${index}`;
	}

	trackByBullet(index: number, bullet: string): string {
		return `${bullet}-${index}`;
	}
}